var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 4",
    d: "M30.7071 7.29289C31.0976 7.68342 31.0976 8.31658 30.7071 8.70711L24.3431 15.0711C23.9526 15.4616 23.3195 15.4616 22.9289 15.0711C22.5384 14.6805 22.5384 14.0474 22.9289 13.6569L28.5858 8L22.9289 2.34315C22.5384 1.95262 22.5384 1.31946 22.9289 0.928932C23.3195 0.538408 23.9526 0.538408 24.3431 0.928932L30.7071 7.29289ZM0 7L30 7V9L0 9L0 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.d724ae402a1dd3f39199b9c2a65eed0a.svg";
export { ForwardRef as ReactComponent };